export type SectionId =
  | "overview"
  | "token"
  | "errors"
  | "add-template-auth"
  | "add-template-marketing"
  | "add-template-utility"
  | "get-template"
  | "send-single"
  | "send-bulk"
  | "message-report"
  | "add-rules"
  | "get-rules";

export interface SidebarItem {
  id?: SectionId;        
  label: string;
  isChild?: boolean;
  isParent?: boolean;    
}

export interface SidebarGroup {
  group: string;
  items: SidebarItem[];
}

export const API_SIDEBAR: SidebarGroup[] = [
  {
    group: "Introduction",
    items: [
      { id: "overview", label: "Overview" },
      { id: "token", label: "Token" },
      { id: "errors", label: "Errors & Codes" },
    ],
  },
  {
    group: "Templates",
    items: [
      { label: "Add Template", isParent: true }, // ✅ non-clickable parent

      { id: "add-template-auth", label: "Authentication", isChild: true },
      { id: "add-template-marketing", label: "Marketing", isChild: true },
      { id: "add-template-utility", label: "Utility", isChild: true },

      { id: "get-template", label: "Get Template" },
    ],
  },
  {
    group: "Send Messages",
    items: [
      { id: "send-single", label: "Send Single Msg Template" },
      // { id: "send-bulk", label: "Send Bulk Msg Template" },
    ],
  },
{
  group: "Train Bot",
  items: [
    { label: "Manage Rules", isParent: true },

    { id: "add-rules", label: "Add Rule", isChild: true },
    { id: "get-rules", label: "Get Rules", isChild: true },
  ],
},
  {
    group: "Reports",
    items: [
      { id: "message-report", label: "Message Report" },
    ],
  },
];